import { __, curry, indexOf, sortBy, pipe, prop } from 'ramda';

export function sortByOrderArray(array, order, field) {
  const sortValue = pipe(prop(field), curry(indexOf)(__, order));

  return sortBy(sortValue, array);
}
